// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"633dd895","239":"9f05c4c2","319":"c06d5e14","339":"8513119c","455":"fe6a6988","473":"6cec2ad5","556":"baf15fe2","609":"ece8221f","640":"01d1edc3","733":"6fd2a46d","901":"720af46a","939":"cc1e1463","977":"7a453675"}[chunkId] + ".chunk.js";
};